import { render } from "./ProviderListView.vue?vue&type=template&id=ce315c7e&scoped=true"
import script from "./ProviderListView.vue?vue&type=script&lang=js"
export * from "./ProviderListView.vue?vue&type=script&lang=js"

import "./ProviderListView.vue?vue&type=style&index=0&id=ce315c7e&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce315c7e"]])

export default __exports__